import { format } from 'date-fns';

const formatDate = (date) => {
  try {
    return format(new Date(date), 'MMMM do yyyy, HH:mm');
  } catch (e) {
    return 'Invalid Date';
  }
};

export default formatDate;
